app.service('wcProductTabWarranties', function() {
	function init() {}

	return {
		init: init
	};
});
